// Alpha2 is the official 2 letter codes for countries as defined by the ISO 3166-1 standard
// in the flexportal we use the lowercase version of the country code, this will return the official
// version. This is used for the API calls.
export const getCountryAsAlpha2Code = (country: CountryIdentifier): string => {
  return country.toUpperCase()
}
